import React, { useContext, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { Icon, InputSelect, InputText } from './index';
import { Bound, BoundMagic, DataContext } from 'opidcore';
import {StatBlock, DateTitle, CircleChart, DiversionHistogram, MaterialGraph, niceRound, ColorBlock, Format} from './Things';
import {FlexBlock, FlexBlockWrapped, PageBlock, Heading, Heading2, Loading, BasicText as Text} from './Styles'
import * as _ from 'lodash';
import styled from 'styled-components/native'
import { COLORS } from '../WasteTheme';
import {Tabular,TabularColumn} from './core/Tabular';

//bring into state/portalData?
let window = {PORTAL_COUNTRY: 'CA'};
const MT_CO2_PER_MT_WASTE = 3.2414553472987;

export default function Summary({portalData, currentMonth}){
        if (portalData.materials == null){
            return null;
        };
    
        const thisMonth = portalData.materials.filter((r)=>r.date == currentMonth);
        const totalTonnes = _.sum(thisMonth.map(r=>r.metric_tonnes));
        
    
        const updateOptions = ()=>{
            console.log("do something");
        }
    
        let kg_title = "kg";
        if (window.PORTAL_COUNTRY == "USA"){
            kg_title = "lb";
        }
        
        return <View>
            <PageBlock>
                <FlexBlockWrapped> 
                    
                    <StatBlock value="9783" icon="garbage" fType="fac" label="Waste" color={COLORS.grey} units="MT"/>
                    <StatBlock value="3340" icon="recycle" label="Recycled" color={COLORS.blue} units="MT"/>
                    <StatBlock value="1100" icon="organics" fType="fac" label="Organics" color={COLORS.green} units="MT"/>
                    <StatBlock value="243" icon="ghg" fType="fac" label="GHG" color={COLORS.blue2} units="MT CO₂"/>

                    <StatBlock value="2800" icon="piggy-bank" label="Savings" color={COLORS.money} symbol="$"/>
                    <StatBlock value="7290" icon="lightbulb-dollar" label="Total Savings" color={COLORS.savings}  symbol="$"/>
                    
                </FlexBlockWrapped>
            </PageBlock>
    
            <FlexBlockWrapped>
            <PageBlock>
                <Heading2><DateTitle month={currentMonth}/> Diversion rate</Heading2>
                <CircleChart data={ [
                    {id: "waste", icon: "garbage", fType: "fac", label: 'Waste', color: COLORS.blackish, value: 100, },
                    {id: "recycle", icon:'recycle', label: 'Recycled', color: COLORS.wsc_blue, value: 68}, 
                    {id: "organics", icon:'organics', fType: "fac", label: 'Organics', color: COLORS.acid_green, value: 68}]  } units="MT" centeredMetric="41%"></CircleChart>
            </PageBlock>

            <PageBlock>
                <Heading2>Historical diversion rate</Heading2>
                <DiversionHistogram data={ portalData.diversion } maxValue={20}/>
            </PageBlock>
            </FlexBlockWrapped>

            <PageBlock>
            <Heading2>Material composition</Heading2>
    
                <FlexBlockWrapped> 
                        <MaterialGraph data={thisMonth} units="MT"/>
                        
                        <Tabular data={thisMonth} widths={["45%","25%","15%","15%"]}>
                            <TabularColumn data={ (row)=><View style={{display: 'flex', alignContent: 'center', flexDirection: 'row'}}><ColorBlock color={row.main_colour}/><Text style={{paddingLeft: 5}}>{row.name}</Text></View> } title="Material class"/>
                            <TabularColumn data={ (row)=>row.material_type } title="Type"/>
                            <TabularColumn data={ (row)=>niceRound(row.metric_tonnes*1000,0)} title={kg_title}/>
                            <TabularColumn data={ (row)=>niceRound(100 * row.metric_tonnes/totalTonnes,1) } title="%"/>
                        </Tabular>
                </FlexBlockWrapped>
            </PageBlock>
    
            <PageBlock>
               <RankBlock portalData={portalData} currentMonth={currentMonth}/>
            </PageBlock>
        </View>;
}

export const RankBlock = ({ portalData, currentMonth, siteView, topRanking = undefined, topRankingField = undefined}) => {
	//const [siteView, setSiteView] = useState("Diversion");
	const options = useRef({});

    if (portalData.materials == null){
        return null;
    }

	const thisMonth = portalData.materials.filter((r)=>r.date == currentMonth);
	const totalTonnes = _.sum(thisMonth.map(r=>r.metric_tonnes));
	let thisMonthSites = portalData.sites.filter((r)=>r.date == currentMonth);
	let rank = 1;
    let widths = null;

	_.each( thisMonthSites, (s)=>{ 
		s.rank = rank++ 
		s.percent_diverted =  s.metric_tonnes_diverted / (s.metric_tonnes_diverted + s.metric_tonnes_waste) * 100;
		if ( isNaN(s.percent_diverted) ){
			s.percent_diverted = 0;
		}
	});

	let siteCols = [ <TabularColumn key="rank" data={(r)=>r.rank} title="Rank"/>,
		<TabularColumn key="mt_name" data={(r)=>r.name} title="Name"/>,
		<TabularColumn key="mt_addr" data={(r)=>r.address} title="Address"/>,
		<TabularColumn key="mt_city" data={(r)=>r.city +", " + r.province} title="City"/> ];
		
	let siteTitle = "?";

    //something sets siteView to null?
	if (siteView == "Diversion"){
		siteTitle = "Landfill diversion ranking";
      
		siteCols.push( <TabularColumn key="div_Target" data={(r)=>r.diversion_target+"%"} title="Diversion Target"/> );
		if (window.PORTAL_COUNTRY == "USA"){
			siteCols.push( <TabularColumn key="mt_tons" data={(r)=>niceRound(r.metric_tonnes_diverted,1)} title="Diverted (Tons)"/> );
		}else{
			siteCols.push( <TabularColumn key="div_mt" data={(r)=>niceRound(r.metric_tonnes_diverted,1)} title="Diverted (MT)"/> );
		}
		
		siteCols.push( <TabularColumn key="div_percent" data={(r)=>niceRound(r.percent_diverted,1)+"%"} title="Diverted (%)"/> );
        
	}
    
    if (siteView == "DiversionSmall"){
		siteTitle = "Landfill diversion ranking";
      
		siteCols.push( <TabularColumn key="div_Target" data={(r)=>r.diversion_target+"%"} title="Target"/> );	
		siteCols.push( <TabularColumn key="div_percent" data={(r)=>niceRound(r.percent_diverted,1)+"%"} title="Diverted"/> );
        widths=["8%","20%","20%","25%","15%","15%"]
	}

	if (siteView == "Savings"){
		siteTitle = "Site savings ranking";
		siteCols.push( <TabularColumn className="right" data={(r)=>Format.asCurrency( r.total_savings )} title="Savings"/> );
	}

	if (siteView == "Carbon Reduction"){
		siteTitle = "Site carbon reduction ranking";

		if (window.PORTAL_COUNTRY == "USA"){
			siteCols.push( <TabularColumn key="mt_rec" data={(r)=>niceRound(r.metric_tonnes_diverted * MT_CO2_PER_MT_WASTE,1) } title="Tons CO₂ Saved (Recycled)"/> );
			siteCols.push( <TabularColumn key="mt_waste" data={(r)=>niceRound(r.metric_tonnes_waste * MT_CO2_PER_MT_WASTE,1) } title="Tons CO₂ Produced (Waste)"/> );
			siteCols.push( <TabularColumn key="mt_div" data={(r)=>niceRound((r.metric_tonnes_diverted - r.metric_tonnes_waste ) * MT_CO2_PER_MT_WASTE,1) } title="Tons CO₂ Net Reduction"/> );
		}else{
			siteCols.push( <TabularColumn key="mt_rec"  data={(r)=>niceRound(r.metric_tonnes_diverted * MT_CO2_PER_MT_WASTE,1) } title="MT CO₂ Saved (Recycled)"/> );
			siteCols.push( <TabularColumn key="mt_waste" data={(r)=>niceRound(r.metric_tonnes_waste * MT_CO2_PER_MT_WASTE,1) } title="MT CO₂ Produced (Waste)"/> );
			siteCols.push( <TabularColumn key="mt_div" data={(r)=>niceRound((r.metric_tonnes_diverted - r.metric_tonnes_waste ) * MT_CO2_PER_MT_WASTE,1) } title="MT CO₂ Net Reduction"/> );
		}
        
	}

    let pageSize = 10;

    if(topRanking != undefined && topRankingField != undefined){
        if(thisMonthSites.length != undefined && thisMonthSites.length-topRanking >= 0){
            thisMonthSites = _.reverse(_.sortBy(thisMonthSites, topRankingField).slice(thisMonthSites.length-topRanking));
            pageSize = null;
        }

        let theRank = 1;
        _.forEach(thisMonthSites, (s)=>{s.rank = theRank++;});
    }
    

	return <>
        {/** <Bound to={options.current}>
            <FlexBlock style={{justifyContent: 'space-between'}}>
                <Heading2>{siteTitle}</Heading2>
                <InputSelect field="viewSitesBy" defaultValue={siteView} options={[{value:"Diversion", label:"Diversion"}, {value:"Savings", label: "Savings"},{value:"Carbon Reduction",label:"Carbon Reduction"}]} onChange={(a,b,c)=>{ if (siteView != c && c != null){ setSiteView(c)} }}/>
            </FlexBlock>
        </Bound> **/}
		<Tabular widths={widths} data={thisMonthSites} pageSize={pageSize}>				
				{siteCols}
		</Tabular> 
	</>;
};